export const UPGRADE_AND_REQUEST_PRODUCT_TEXT_KEY = "UPGRADE_AND_REQUEST_PRODUCT_TEXT";
export const UPGRADE_AND_REQUEST_PRODUCT_TEXT = "Upgrade e richiedi";

export const UPGRADE_AND_DISCOVER_PRODUCT_TEXT_KEY = "UPGRADE_AND_DISCOVER_PRODUCT_TEXT";
export const UPGRADE_AND_DISCOVER_PRODUCT_TEXT = "Upgrade e scopri";

export const UPGRADE_AND_CHAT_WITH_CLARA_TEXT_KEY = "UPGRADE_AND_CHAT_WITH_CLARA_TEXT";
export const UPGRADE_AND_CHAT_WITH_CLARA_TEXT = "Upgrade e chatta";

export const COMPARE_PLANS_TEXT_KEY = "COMPARE_PLAN_TEXT";
export const COMPARE_PLANS_TEXT = "Confronta i piani";

export const UPGRADE_PLAN_TEXT_KEY = "UPGRADE_PLAN_TEXT";
export const UPGRADE_PLAN_TEXT = "Upgrade piano";

export const REACTIVATE_PLAN_TEXT_KEY = "REACTIVATE_PLAN_TEXT";
export const REACTIVATE_PLAN_TEXT = "Abbonati di nuovo";
